/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../../shared/services/storage.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { type Observable } from 'rxjs/internal/Observable';
import { AccountDetail } from '../../../shared/models/account-detail';
import { StorageEnum } from '../../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../../shared/services/payment.service';
import { CTA, SuccessData } from '../../../shared/models/success-data.model';
import { AutoPayChangeData } from '../../../shared/models/auto-pay-change';
import { format, toDate } from 'date-fns';
import { AutoPayCancel } from '../../../shared/models/autopay-cancel';
import { PaymentAccountType } from '../../../shared/enums/paymentaccounttype.enum';
import { AutoPay } from '../../../shared/models/auto-pay';
import { type PaymentMethod } from '../../../shared/models/payment-method';
import { type UserProfile } from '../../../shared/models/user-profile';
import { catchError, concatMap, EMPTY, tap } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentAccountTypeDisplayNamePipe } from '../../../shared/pipes/payment-account-type-display-name.pipe';
import { Nav } from '../../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../../shared/services/error.service';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, Validators } from '@angular/forms';
import { emailValidator } from '../../../shared/validators/email.validator';
import { EmailInfo } from '../../../shared/models/email-info';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../../shared/services/account.service';
import { EmailFormComponent } from '../../../shared/components/email-form/email-form.component';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../../shared/services/seo.service';
import { NotificationType } from '../../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../../shared/services/notifications.service';

@Component({
  selector: 'app-autopay-cancel',
  imports: [
    MatDividerModule, //
    MatButtonModule,
    EmailFormComponent,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
  ],
  providers: [PaymentAccountTypeDisplayNamePipe],
  templateUrl: './autopay-cancel.component.html',
  styleUrl: './autopay-cancel.component.scss',
})
export class AutopayCancelComponent {
  pageReady = false;
  accountDetail: AccountDetail = new AccountDetail();
  userProfile?: UserProfile;
  pageLabels$!: Observable<any>;
  pageLabels: any = {};
  apiError: string = '';
  formErrorMessage: string = '';
  apiErrors: any[] = [];
  showAutoPayChangeHeader = false;
  autoPayErrors: any[] = [];
  isBrowser = false;
  emailFormData: any = {};
  hasEmail: boolean = false;
  headerData = new PageHeader();
  pageName = Nav.AutopayCancel;

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly utils: UtilService,
    private readonly cms: CmsService,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly payment: PaymentService,
    private readonly patDisplayName: PaymentAccountTypeDisplayNamePipe,
    private readonly error: ErrorService,
    private readonly fb: FormBuilder,
    private readonly account: AccountService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
      this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
      this.autoPayErrors = this.storage.getSession(StorageEnum.GlobalVars)?.autoPayErrors;
    }
  }

  ngOnInit(): void {
    this.cms.getContent('oas-autopay-change-cancel', 'AutoPayChangeCancel').subscribe((data) => {
      this.pageLabels = data;
      this.seoS.setSeoTags(data.seo);
    });

    if (this.checkForAutoPayChange()) {
      this.showAutoPayChangeHeader = true;
    }
    this.headerData.Message = this.showAutoPayChangeHeader
      ? this.pageLabels.autoPayChangeHeaderText
      : this.pageLabels.autoPayCancelHeaderText;

    this.hasEmail =
      this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
        return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
      })?.IsPrimary ?? false;
    if (!this.hasEmail) {
      this.setupEmailData();
    }
    if (this.isBrowser) {
      this.getPreferredPayments().subscribe(); // need to load preferred payment, so we can delete it when We cancel autopay
      this.pageReady = true;
      this.utils.hideSpinner();
    }
  }

  getPreferredPayments(): Observable<any> {
    return this.payment.getPreferredPayments(this.accountDetail).pipe(
      tap((data: any) => {
        this.storage.setSession(StorageEnum.PaymentMethods, data.PaymentMethods);
      }),
    );
  }

  cancelAutoPay(): void {
    const today = format(new Date().toString(), 'MM/dd/yyyy');
    const billDueDate = format(toDate(this.accountDetail.CurrentBalanceDueDate!).toString(), 'MM/dd/yyyy');
    const autoPayEnrollDate = format(toDate(this.accountDetail.AutoPay!.StartDate!).toString(), 'MM/dd/yyyy');
    // if auto pay enrollment date is today or current bill due date is today not eligible
    if (billDueDate === today) {
      this.setErrorDataEnrolledSameBillDate();
      void this.router.navigateByUrl(Nav.ErrorPage);
    } else if (autoPayEnrollDate === today) {
      this.setErrorDataEnrolledSameDay();
      void this.router.navigateByUrl(Nav.ErrorPage);
    } else {
      this.utils.showSpinner();
      if (!this.hasEmail) {
        // handle new email stuff
        // according to ticket, even if this call fails we continue with payment, so we don't really need to do anything with the response
        if (this.emailFormData.formGroup.valid) {
          const emailValue = this.emailFormData.formGroup.value.email;

          const personRequest = this.accountDetail?.Person;
          const email = new EmailInfo();
          email.ContactId = '';
          email.Email = emailValue;
          email.IsActive = true;
          email.IsPrimary = true;
          email.Type = 'EMAIL';
          personRequest?.EmailAddresses?.push(email);
          this.account.UpdatePersonContact(personRequest).subscribe({
            error: (e) => {
              this.utils.consoleLog('There was an error adding email on payments page. Error: ' + e);
            },
            next: (data: any) => {
              this.accountDetail.Person = data;
              this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
              this.hasEmail = true;
            },
          });
        } else {
          const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
          this.emailFormData.formGroup.markAllAsTouched();
          this.showFormErrorLabel(errorMessage);
          this.utils.hideSpinner();
          return;
        }
      }
      const autoPayCancelRequest = new AutoPayCancel();
      autoPayCancelRequest.AccountNumber = this.accountDetail.AccountNumber;
      autoPayCancelRequest.RecurringScheduleId = this.accountDetail.AutoPay?.RecurringScheduleId;
      autoPayCancelRequest.CustomerClass = this.accountDetail.CustomerClass;

      if (this.accountDetail.AutoPay?.PaymentAccountType === PaymentAccountType.Banking) {
        this.payment
          .cancelAutoPayBank(autoPayCancelRequest)
          .pipe(
            catchError((e) => {
              this.setErrorData(e.message);
              void this.router.navigateByUrl(Nav.ErrorPage);
              return EMPTY;
            }),
            concatMap((data: any) => {
              return this.deleteAutoPayPaymentMethod();
            }),
          )
          .subscribe(() => {
            this.redirectToEnroll();
          });
      } else {
        this.payment
          .cancelAutoPayCard(autoPayCancelRequest)
          .pipe(
            catchError((e) => {
              this.setErrorData(e.message);
              void this.router.navigateByUrl(Nav.ErrorPage);
              return EMPTY;
            }),
            concatMap((data: any) => {
              return this.deleteAutoPayPaymentMethod();
            }),
          )
          .subscribe(() => {
            this.redirectToEnroll();
          });
      }
    }
  }

  deleteAutoPayPaymentMethod(): Observable<any> {
    this.utils.showSpinner();

    const savedPayMethods = this.storage.getSession(StorageEnum.PaymentMethods);
    if (savedPayMethods !== null) {
      const autoPayMethod: PaymentMethod = savedPayMethods.find((pm: PaymentMethod) => {
        return pm.IsAssociatedAutoPay === true;
      });

      autoPayMethod.ActionCode = 'D';
      autoPayMethod.AccountNumber = this.accountDetail.AccountNumber;
      autoPayMethod.UserName = this.userProfile?.UserName;

      return this.payment.updatePreferredPayment(autoPayMethod).pipe(
        catchError(() => {
          this.redirectToEnroll();
          return EMPTY;
        }),
        concatMap(() => {
          return this.getPreferredPayments();
        }),
      );
    } else {
      return EMPTY;
    }
  }

  redirectToEnroll(): void {
    if (this.showAutoPayChangeHeader) {
      this.setAutoPayChangeData();
      void this.router.navigateByUrl(Nav.AutopayChange);
    } else {
      this.setSuccessData();
      this.accountDetail.IsAutoPay = false;
      this.accountDetail.AutoPay = new AutoPay();
      this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
      void this.router.navigateByUrl(Nav.PaymentSuccess);
    }
  }

  setSuccessData(): void {
    const successLabels = this.pageLabels.autoPayCancelSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    successData.Subheader = successLabels.subheaderText;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'makePayment';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = acctCTA.ctaUrl;
    successData.CTAList.push(cta);
    successData.Details = [];
    this.storage.setSession(StorageEnum.SuccessData, successData);
  }

  setAutoPayChangeData(): void {
    const autoPayChangeData = new AutoPayChangeData();
    autoPayChangeData.LastFour = this.accountDetail.AutoPay?.AccountNumber;
    autoPayChangeData.PaymentType = this.payment.isCardBankDigital(this.accountDetail.AutoPay?.PaymentAccountType);
    autoPayChangeData.PaymentAccountType = this.patDisplayName.transform(
      this.accountDetail.AutoPay?.PaymentAccountType,
    );
    this.storage.setSession(StorageEnum.ChangeAutoPayData, autoPayChangeData);
  }

  setErrorDataEnrolledSameDay(): void {
    if (this.showAutoPayChangeHeader) {
      this.error.setErrorData('none', this.pageLabels.errors[3].error);
    } else {
      this.error.setErrorData('none', this.pageLabels.errors[1].error);
    }
  }

  setErrorDataEnrolledSameBillDate(): void {
    if (this.showAutoPayChangeHeader) {
      this.error.setErrorData('none', this.pageLabels.errors[4].error);
    } else {
      this.error.setErrorData('none', this.pageLabels.errors[0].error);
    }
  }

  setErrorData(errorCode: string): void {
    if (this.showAutoPayChangeHeader) {
      this.error.setErrorData(errorCode, this.pageLabels.errors[5].error);
    } else {
      this.error.setErrorData(errorCode, this.pageLabels.errors[2].error);
    }
  }

  checkForAutoPayChange(): boolean {
    if (this.router.url.includes('autopay-cancel-change')) {
      return true;
    } else {
      return false;
    }
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  showFormErrorLabel(errorMessage: string): void {
    this.formErrorMessage = errorMessage;
    if (this.formErrorMessage && this.formErrorMessage !== '') {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }
}
